import React , { useState  } from 'react';
import noImage from '../asset/image/no-image-icon.png';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css'
import {url} from './resapi'
import {Link,withRouter} from 'react-router-dom';
const SlideRecommend =(props)=>{
  const [swiper, setSwiper] = useState(null);
  const params = {
    Swiper,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
    }
  }
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };
 
  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };
  props.history.listen((location, action) => {
    window.location.reload()
  });
  return(
    <div className="slide_recommend">
    <div className="title">{props.title}</div>
    <div className="row" style={{fontSize:"4em"}}>
      <Swiper {...params} getSwiper={setSwiper}>
      {props.data.map((data,key)=>
        <div className="col-lg-3 col-md-6 col-6" key={key}>
          <div className="post clickable">
          <div className="image">
          <Link to={`/${props.route.pagename}/${data.name.split(" ").join("-")}`}><img src={data.previewAlso?url+"/"+data.previewAlso:noImage} alt={data.name}/></Link>
          </div>
          <div className="text">
          <Link to={`/${props.route.pagename}/${data.name.split(" ").join("-")}`}><h4>{data.name}</h4></Link>
          <Link to={`/${props.route.pagename}/${data.name.split(" ").join("-")}`}><p>{data.html}</p></Link>
          </div>
          </div>
        </div>
      )}
      </Swiper>
      

      <div className="arrow">
        <span className="left clickable" onClick={goPrev}><i className="icon icon-arrow-left"></i></span>
        <span className="right clickable" onClick={goNext}><i className="icon icon-arrow-right"></i></span>
      </div>

    </div>
  </div>
  )
}
export default withRouter(SlideRecommend)